import { useState, useCallback } from 'react';
import { message } from 'antd';
import { c358Api, QueryParams, ReportRow, CurrencySummary, GroupCount } from '../../../services/c358Api';

export function useC358Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ReportRow[]>([]);
  const [currencySummary, setCurrencySummary] = useState<CurrencySummary[]>([]);
  const [groupCounts, setGroupCounts] = useState<GroupCount[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await c358Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setCurrencySummary(resp.currency_summary || []);
        setGroupCounts(resp.group_counts || []);
        setNoData(false);
      } else {
        setData([]);
        setCurrencySummary([]);
        setGroupCounts([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setCurrencySummary([]);
    setGroupCounts([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, currencySummary, groupCounts, queried, noData, runQuery, reset };
}
